import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'selector',
    template: require('./mapa.component.html')
})
export class MapaComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/mapa/mapa.component.ts
 **/